import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { startServices } from "./services";
import { followNativeLinks } from "./native-links";
import { ErrorBoundary } from "./ErrorBoundary";
import { registerVersion, trackAppOpened } from "./analytics";
import { installErrorReporting, reportError } from "./telemetry";
import { watchGlassBars } from "./glass";
import "./styles.css";
import "./design.css";

installErrorReporting();
watchGlassBars();
registerVersion();
trackAppOpened();
const root = createRoot(document.getElementById("root")!);

startServices().then(
  async (services) => {
    if (await followNativeLinks()) return; // the Android app was opened with a link: the page is moving to it
    root.render(
      <StrictMode>
        <ErrorBoundary>
          <App services={services} />
        </ErrorBoundary>
      </StrictMode>,
    );
    if ("serviceWorker" in navigator && import.meta.env.PROD) {
      navigator.serviceWorker.register("/sw.js").catch((e) => reportError("service-worker", e));
    }
  },
  (err) => {
    reportError("startup", err);
    // Without storage and WebCrypto this phone cannot hold an identity, so it cannot pair at all.
    document.getElementById("root")!.innerHTML = `<div style="padding:24px;font:16px -apple-system,system-ui,sans-serif;color:#888">
      <b>This browser can't run Brocoded.</b><br/>It needs secure storage and Web Crypto (open it over https or on localhost).<br/><small>${String(err)}</small></div>`;
  },
);
